import CELL_DATA_TYPES from '../cell-types.config';
// import { ACTIONS } from '../const.config';

export const LISTING_COLUMNS = [
  {
    id: 'email',
    label: 'Email',
    width: '20%',
    align: 'left',
    dataKey: 'email',
    sortable: true,
    type: CELL_DATA_TYPES.EMAIL,
  },
  {
    id: 'isInvited',
    label: 'Is Invited?',
    width: '5%',
    align: 'center',
    dataKey: 'isInvited',
    sortable: true,
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '7%',
    align: 'left',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'createdByName',
    label: 'Created By',
    width: '7%',
    align: 'right',
    dataKey: 'createdByName',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
];

export const LISTING_ACTIONS = [
  //   {
  //     action: ACTIONS.DELETE.value,
  //     label: ACTIONS.DELETE.label,
  //   },
];
